import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye exactamente el MEGAPACK?',
  a: 'El Megapack incluye 6 tomos digitales con planificación anual, mensual y semanal, sesiones por área, proyectos, evaluación, registros y formatos. Si eliges el Sistema Aula Lista™, también te llevas el sistema visual completo de organización y aplicación en aula.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todo el material en formato PDF de alta calidad, listo para descargar, imprimir y usar al instante.'
}, {
  q: '¿Sirve para mi país?',
  a: '¡Sí! El material está diseñado con un lenguaje neutro y metodologías universales de educación, perfecto para cualquier país de Latinoamérica.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a nuestra plataforma privada donde podrás descargar todo el contenido.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía incondicional. Si sientes que el material no es para ti, nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Cuál es la diferencia entre el pack básico y el Sistema Aula Lista?',
  a: 'El pack básico te da todo el contenido académico (planificación, sesiones, evaluación y formatos). El Sistema Aula Lista te da, además, las herramientas visuales para organizar, controlar y aplicar todo en el aula de forma más clara (paneles, tarjetas, señales, planificadores).'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-102">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-103">
          {faqs.map((faq, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-104">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-105">
                <span className="font-bold text-white text-sm pr-4" data-id="element-106">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-107" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-108" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-109">
                  <div className="pt-3" data-id="element-110">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}